export class MachineGroupScheduleTimeRange {
  constructor(
    public hash?: string,
    public reference?: string,
    public color?: string,
    public startTime?: number,
    public endTime?: number,
    public defaultRange?: boolean,
  ) { }

  clone() {
    return new MachineGroupScheduleTimeRange(
      this.hash,
      this.reference,
      this.color,
      this.startTime,
      this.endTime,
      this.defaultRange
    );
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/calendar/machine-group-schedule-time-range.ts